import React from "react";
import { BlockMath } from "react-katex";

function getLatexString(dividend, divisor) {
  let latexExpressionTemplate = `\\frac{\\text{\\textit{${dividend}}} \\ast \\textit{100}}{\\text{\\textit{${divisor}}}}`;
  return latexExpressionTemplate;
}

const de = (
  <div>
    <p>
      Der Gemeinkostenfaktor drückt das Verhältnis der Gemeinkosten in % im Verhältnis zum Bruttolohn in % aus. Der Bruttolohn
      ist immer 100%.
    </p>
    <BlockMath>{getLatexString("Gemeinkosten in \\%", "Bruttolohn in \\%")}</BlockMath>
  </div>
);

const fr = (
  <div>
    <p>
      Le taux de frais généraux exprime le rapport entre les frais généraux (en %) et le salaire brut (en %). Le salaire brut
      est toujours fixé à 100 %.
    </p>
    <BlockMath>{getLatexString("Frais généraux en \\%", "Salaire brut en \\%")}</BlockMath>
  </div>
);

const it = (
  <div>
    <p>
      Il fattore di spese generali esprime il rapporto tra le spese generali in % e il salario lordo in %. Il salario lordo
      è sempre del 100%.
    </p>
    <BlockMath>{getLatexString("Spese generali in \\%", "Salario lordo in \\%")}</BlockMath>
  </div>
);

const en = (
  <div>
    <p>Overhead factor expresses the ratio of overhead costs in % to gross salary in %. Gross salary is always 100%.</p>
    <BlockMath>
      {getLatexString("Overhead costs in \\%", "Gross salary in \\%")}
    </BlockMath>
  </div>
);

let text = {
  de,
  fr,
  it,
  en,
};

export default text;
